import { render, staticRenderFns } from "./positivesalon-audio-new-player.vue?vue&type=template&id=3a8ed859&scoped=true&"
import script from "./positivesalon-audio-new-player.vue?vue&type=script&lang=js&"
export * from "./positivesalon-audio-new-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8ed859",
  null
  
)

export default component.exports